export const GENERIC_PREVIEW_ERROR_DESCRIPTION =
  'An error occurred while loading this content. Please try again later.'
